import { useContext, useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { useLocation } from "react-router-dom";

import { API_BASE_URL } from "../api_config";
import UserContext from "../Authcontext";
import { useSearchContext } from "../SearchContext";
import {
  fetchEducationData,
  fetchMultiKulam,
  fetchMultiStar,
} from "../apis";
import SearchFilter from "./SearchFilter";

import searchImg from "../../assets/search.png";
import searchNo from "../../assets/srchno.png";

import "./search.css";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "auto",
    minHeight: "40px",
    width: "200px",
    borderRadius: "10px",
    boxShadow: "none",
    borderColor: "#e4e4e4",
    color: "#000000",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: "9999",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "200px",
    overflowY: "scroll",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e4e4e4",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#333",
    ":hover": {
      backgroundColor: "#e4e4e4",
      color: "#333",
    },
  }),
};

function SearchBox() {
  const { user } = useContext(UserContext);
  const { updateSearchResults, clearSearchResults, searchResults, isFromSearch } = useSearchContext();
  const location = useLocation();
  const [filterData, setFilterData] = useState([]);
  const [minAge, setMinAge] = useState(20);
  const [maxAge, setMaxAge] = useState(30);
  const [martialstatus, setMaritalStatus] = useState("");
  const [mothertongue, setMotherTongue] = useState("");
  const [religion, setReligion] = useState("");
  const [kulam, setKulam] = useState([]);
  const [star, setStar] = useState([]);
  const [education, setEducation] = useState([]);
  const [annualincome, setAnnualIncome] = useState("");
  const [city, setCity] = useState("");
  const [eduData, setEduData] = useState([]);
  const [starData, setStarData] = useState([]);
  const [kulamData, setKulamData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [showContent, setShowContent] = useState(true);

  // Clear search results when navigating away from search page
  useEffect(() => {
    const handleRouteChange = () => {
      if (!location.pathname.includes('/search')) {
        clearSearchResults();
      }
    };

    // Clear results when component unmounts or route changes
    return () => {
      if (!location.pathname.includes('/search')) {
        clearSearchResults();
      }
    };
  }, [location.pathname, clearSearchResults]);

  // Initialize filterData from context if available
  useEffect(() => {
    if (isFromSearch && searchResults.length > 0) {
      setFilterData(searchResults);
      setShowContent(false);
    }
  }, [isFromSearch, searchResults]);

  const fetchData = (url, successCallback) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
        successCallback(sortedData);
      })
      .catch((error) => alert("Something error occurred, please try again"));
  };

  useEffect(() => {
    fetchData(`${API_BASE_URL}/api/cities`, setCityData);
    fetchSearchOptions();
  }, []);

  const fetchSearchOptions = async () => {
    const eData = await fetchEducationData();
    const strData = await fetchMultiStar();
    const klmData = await fetchMultiKulam();

    setEduData(eData);
    setStarData(strData);
    setKulamData(klmData);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const selectedEducation = education.map((edu) => edu.value);
    const selectedKulam = kulam.map((klm) => klm.value);
    const selectedStar = star.map((str) => str.value);

    axios
      .get(`${API_BASE_URL}/api/Search`, {
        params: {
          id: user.user_id,
          gender: user.gender,
          membership: user.pay_membership,
          minAge,
          maxAge,
          martialstatus,
          mothertongue,
          religion,
          kulam: selectedKulam,
          star: selectedStar,
          education: selectedEducation,
          annualincome,
          city,
        },
        withCredentials: true,
      })
      .then((res) => {
        if (Array.isArray(res.data)) {
          setShowContent(false);
          setFilterData(res.data);
          // Store results in global context
          updateSearchResults(res.data);
          if (window.innerWidth >= 700) {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        }
      })
      .catch((err) => alert("Something error occured"));
  };

  return (
    <div className="search-main-cont">
      <div className="simplified-search-sidebar">
        <div className="simplified-search-header">
          <h3>Search Partner Profiles</h3>
        </div>
        
        <form className="simplified-search-form">
          <div className="simplified-search-group">
            <label className="simplified-search-label-title">Age Range</label>
            <div className="simplified-age-range">
              <div className="simplified-search-field">
                <label className="simplified-search-label" htmlFor="minAge">Min Age</label>
                <select
                  className="simplified-search-select"
                  id="minAge"
                  value={minAge}
                  onChange={(e) => {
                    const selectedValue = parseInt(e.target.value);
                    setMinAge(selectedValue);
                    if (selectedValue > maxAge) {
                      setMaxAge(selectedValue);
                    }
                  }}
                >
                  {[...Array(41)].map((_, index) => (
                    <option key={index + 20} value={index + 20}>
                      {index + 20}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="simplified-search-field">
                <label className="simplified-search-label" htmlFor="maxAge">Max Age</label>
                <select
                  className="simplified-search-select"
                  id="maxAge"
                  value={maxAge}
                  onChange={(e) => setMaxAge(parseInt(e.target.value))}
                >
                  {[...Array(81 - parseInt(minAge, 10))].map((_, index) => {
                    const maxValue = parseInt(minAge, 10) + index;
                    return (
                      <option key={maxValue} value={maxValue}>
                        {maxValue}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
          
          <div className="simplified-search-group">
            <label className="simplified-search-label-title">Basic Details</label>
            
            <div className="simplified-search-field">
              <label className="simplified-search-label" htmlFor="maritalstatus">Marital Status</label>
              <select
                className="simplified-search-select"
                id="maritalstatus"
                value={martialstatus}
                onChange={(e) => setMaritalStatus(e.target.value)}
              >
                <option value="">Any</option>
                <option value="UnMarried">Never Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widow">Widow</option>
                <option value="Awaiting divorce">Awaiting Divorce</option>
              </select>
            </div>
            
            <div className="simplified-search-field">
              <label className="simplified-search-label" htmlFor="mothertongue">Mother Tongue</label>
              <select
                className="simplified-search-select"
                id="mothertongue"
                value={mothertongue}
                onChange={(e) => setMotherTongue(e.target.value)}
              >
                <option value="">Any</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Kannada">Kannada</option>
                <option value="Hindi">Hindi</option>
                <option value="Marathi">Marathi</option>
                <option value="Gujarati">Gujarati</option>
                <option value="Bengali">Bengali</option>
                <option value="Punjabi">Punjabi</option>
                <option value="Urdu">Urdu</option>
                <option value="Sanskrit">Sanskrit</option>
                <option value="Other">Other</option>
              </select>
            </div>
            
            <div className="simplified-search-field">
              <label className="simplified-search-label" htmlFor="religion">Religion</label>
              <select
                className="simplified-search-select"
                id="religion"
                value={religion}
                onChange={(e) => setReligion(e.target.value)}
              >
                <option value="">Any</option>
                <option value="Hinduism">Hinduism</option>
                <option value="Christianity">Christianity</option>
                <option value="Islam">Islam</option>
                <option value="Sikhism">Sikhism</option>
                <option value="Buddhism">Buddhism</option>
                <option value="Jainism">Jainism</option>
                <option value="Judaism">Judaism</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
          
          <div className="simplified-search-group">
            <label className="simplified-search-label-title">Community</label>
            
            <div className="simplified-search-field">
              <label className="simplified-search-label" htmlFor="kulam">Kulam</label>
              <Select
                className="simplified-search-select"
                id="kulam"
                options={kulamData}
                value={kulam}
                onChange={(selectedOptions) => setKulam(selectedOptions)}
                isMulti
                placeholder="Select Kulam"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    borderRadius: "8px",
                    minHeight: "40px",
                    border: "1px solid var(--border-light)",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
            
            <div className="simplified-search-field">
              <label className="simplified-search-label" htmlFor="star">Star</label>
              <Select
                className="simplified-search-select"
                id="star"
                options={starData}
                value={star}
                onChange={(selectedOptions) => setStar(selectedOptions)}
                isMulti
                placeholder="Select Star"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    borderRadius: "8px",
                    minHeight: "40px",
                    border: "1px solid var(--border-light)",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
          </div>
          
          <div className="simplified-search-group">
            <label className="simplified-search-label-title">Education & Career</label>
            
            <div className="simplified-search-field">
              <label className="simplified-search-label" htmlFor="education">Education</label>
              <Select
                className="simplified-search-select"
                id="education"
                options={eduData}
                value={education}
                onChange={(selectedOptions) => setEducation(selectedOptions)}
                isMulti
                placeholder="Select Education"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: "100%",
                    borderRadius: "8px",
                    minHeight: "40px",
                    border: "1px solid var(--border-light)",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
            
            <div className="simplified-search-field">
              <label className="simplified-search-label" htmlFor="annualincome">Annual Income</label>
              <select
                className="simplified-search-select"
                id="annualincome"
                value={annualincome}
                onChange={(e) => setAnnualIncome(e.target.value)}
              >
                <option value="">Any</option>
                <option value="500000">Less than ₹5,00,000</option>
                <option value="1000000">₹5,00,000 - ₹10,00,000</option>
                <option value="1500000">₹10,00,000 - ₹15,00,000</option>
                <option value="2000000">₹15,00,000 - ₹20,00,000</option>
              </select>
            </div>
          </div>
          
          <div className="simplified-search-group">
            <label className="simplified-search-label-title">Location</label>
            
            <div className="simplified-search-field">
              <label className="simplified-search-label" htmlFor="city">City</label>
              <select
                className="simplified-search-select"
                id="city"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              >
                <option value="">Any</option>
                {cityData.map((cty) => (
                  <option key={cty.id} value={cty.id}>
                    {cty.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="simplified-search-actions">
            <button
              type="button"
              className="simplified-search-button"
              onClick={(e) => handleSearch(e)}
            >
              Search Profiles
            </button>
            <button
              type="button"
              className="simplified-reset-button"
              onClick={() => {
                setMinAge(20);
                setMaxAge(30);
                setMaritalStatus("");
                setMotherTongue("");
                setReligion("");
                setKulam([]);
                setStar([]);
                setEducation([]);
                setAnnualIncome("");
                setCity("");
              }}
            >
              Reset Filters
            </button>
          </div>
        </form>
      </div>
      
      <div className="simplified-search-results">
        {showContent ? (
          <div className="search-empty-state">
            <img src={searchImg} alt="SEARCH" className="search-empty-image" />
            <h1>Find your perfect match</h1>
          </div>
        ) : filterData.length === 0 ? (
          <div className="search-empty-state">
            <img src={searchNo} alt="NOTHING" className="search-empty-image" />
            <h1>No matches found, try other filter options</h1>
          </div>
        ) : (
          <SearchFilter filterData={filterData} />
        )}
      </div>
    </div>
  );
}

export default SearchBox;